import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {
    init: function() {
      if ( $( '.js-before-and-after-single-splide' ).length ) {
        const slider = new Splide( '.js-before-and-after-single-splide', {
          type: 'loop',
          perPage: 1,
          pagination: false,
          padding: {right: '150px'},
          gap: '20px',
          speed: 800,
        } ).mount();
      }
    },

    finalize: function() {
    },
  };

  app.registerComponent( 'before-and-after-single', COMPONENT );
} )( app );
